// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_50-7";
export var adjustableWidthBorderHeld = "_50-8";
export var arrow = "_50-3";
export var arrowButton = "_50-4";
export var headerCell = "_50-0";
export var help = "_50-2";
export var icon = "_50-1";
export var iconWrapper = "_50-6";
export var noBorder = "_50-b";
export var nonAdjustableWidthBorder = "_50-9";
export var nonAdjustableWidthBorderHeld = "_50-a";
export var textButton = "_50-5";